import DesktopNav from "../../../components/DesktopNav";
import { HomeScreenType } from "../../../helpers/Enums";
import BottomNav from "../../../components/BottomNav";
import SearchCarpet from "./SearchCarpet";

const SearchMembersResultsView = () => {
  return (
    <>
      <SearchCarpet />
      <DesktopNav screenType={HomeScreenType.HOME} />
      <BottomNav screenType={HomeScreenType.HOME} />
    </>
  );
};

export default SearchMembersResultsView;
